import FJVideoRemoveBgAutoLeft from '../view/FJVideoRemoveBgAutoLeft';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FJActionVideoRemoveBg from '../../../../redux/action/FJActionVideoRemoveBg';
import { VIDEO_AUTO_REMOVE_BG_USE_CREDIT } from '../../../../redux/slices/FJSliceVideoBgRemover';
import PropTypes from 'prop-types';
import useDefaultFreeLimit from '../../../../hooks/useDefaultFreeLimit.jsx';
import FJConfig from '../../../../config/FJConfig.js';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';
import { FJVideoRemoveBgDataConfig } from '../../../../config/dataConfig/FJVideoRemoveBgDataConfig.js';
import {
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS,
    DEFAULT_FILE_TYPES,
} from '../../../../config/dataConfig/FJGenerateData.js';

const FJVideoRemoveBgAutoLeftContainer = ({ isShow }) => {
    const dispatch = useDispatch();

    const autoEditVideoIsUploading = useSelector(state => state.videoBgRemover.autoEditVideoIsUploading);
    const autoRemoverStatus = useSelector(state => state.videoBgRemover.autoRemoverStatus);
    const autoEditVideoInfo = useSelector(state => state.videoBgRemover.autoEditVideoInfo);
    const autoExportStatus = useSelector(state => state.videoBgRemover.autoExportData.exportStatus);
    const isTrimVideo = useSelector(state => state.videoBgRemover.autoRemoverIsTrimVideo);
    const videoAutoBackgroundRemoveFreeNum = useSelector(
        state => state.videoBgRemover.videoAutoBackgroundRemoveFreeNum,
    );
    const creditNumber = useSelector(state => state.common.creditNumber);

    const isFree = videoAutoBackgroundRemoveFreeNum > 0 && VIDEO_AUTO_REMOVE_BG_USE_CREDIT > creditNumber;

    const _uploadVideo = useCallback(
        file => {
            dispatch(FJActionVideoRemoveBg.uploadAutoEditVideoAction(file));
        },
        [dispatch],
    );

    const _uploadBeforeCallback = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.pauseAction());
    }, [dispatch]);

    const _exportVideo = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.autoExportVideoAction());
    }, [dispatch]);

    const _removeAll = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.removeAllAction());
    }, [dispatch]);

    const _openMediaLibrary = useCallback(() => {
        dispatch(
            FJActionEditPage.openMediaLibraryAction({
                uploadConfig: {
                    isMultiple: false,
                    maxMediaNum: 1,
                    selectedMediaIds: [],
                    acceptTypeWithTranscode:
                        FJVideoRemoveBgDataConfig.ACCEPT_FILE_TYPE + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS,
                    acceptTypeNoTranscode: [
                        ...FJVideoRemoveBgDataConfig.SUPPORTED_VIDEO_FORMATS,
                        ...DEFAULT_FILE_TYPES,
                    ],
                    suffixTranscode: CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS,
                    // 媒体库的过滤规则
                    mediaFilterFunc: item => {
                        const mediaTypes = ['VIDEO'];
                        return mediaTypes.includes(item.type);
                    },
                    // 上传文件之后返回的数据
                    callbackOptions: {},
                },
            }),
        );
    }, []);

    const defaultFreeNumCreation = useDefaultFreeLimit(FJConfig.autoRemoverLimitType);

    return (
        <FJVideoRemoveBgAutoLeft
            autoEditVideoIsUploading={autoEditVideoIsUploading}
            autoRemoverStatus={autoRemoverStatus}
            autoEditVideoInfo={autoEditVideoInfo}
            autoExportStatus={autoExportStatus}
            freeNumCreation={videoAutoBackgroundRemoveFreeNum}
            isFree={isFree}
            isTrimVideo={isTrimVideo}
            isShow={isShow}
            uploadVideo={_uploadVideo}
            uploadBeforeCallback={_uploadBeforeCallback}
            exportVideo={_exportVideo}
            removeAll={_removeAll}
            defaultFreeNumCreation={defaultFreeNumCreation}
            openMediaLibrary={_openMediaLibrary}
        />
    );
};

FJVideoRemoveBgAutoLeftContainer.propTypes = {
    isShow: PropTypes.bool,
};

export default FJVideoRemoveBgAutoLeftContainer;
